import { Box, ColorOptions, Image, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'

interface DevCentricInterface {
  isTab: boolean
  isMobile: boolean
}

const BusinessNeeds = ({ isTab, isMobile }: DevCentricInterface) => {
  const { headerSize, textSize } = useFontSize()
  const businessNeeds = require('../../assets/images/business-needs.png')

  const { navigate } = useNavigation()
  const handleNav = () => {
    navigate('products')
  }

  const rightArrow = require('../../assets/images/arrow-right-blue.png')

  return (
    <Box flexDirection={isMobile ? 'column' : 'row'} justify={'space-between'} pt={isMobile ? 96 : 240}>
      <Box f={isMobile ? undefined : 1} align={isMobile ? 'center' : undefined} pl={12}>
        <Image
          source={businessNeeds}
          height={isMobile ? 240 : 340}
          width={isMobile ? '90%' : 410}
          resizeMode="contain"
        />
      </Box>
      <Box f={isMobile ? undefined : 1} justify={'center'} mt={isMobile ? 24 : undefined}>
        <Box pr={isMobile ? 10 : isTab ? 32 : 140}>
          <Text
            title={staticStrings.businessNeeds}
            fontFamily={'jiotype-black'}
            fontSize={headerSize}
            color={'BLACK_21'}
          />
          <Spacer size={isMobile ? 16 : 32} />
          <Text
            title={staticStrings.businessPara}
            fontFamily={'jiotype-medium'}
            fontSize={textSize}
            lineHeight={isMobile ? 20 : 28}
            color={'BLACK_21'}
            opacity={0.9}
          />
        </Box>
        <Box flexDirection={'row'} onPress={handleNav} mt={isMobile ? 24 : 0}>
          <Text
            textDecorationLine={isTab ? 'underline' : 'none'}
            textDecorationStyle="dotted"
            color={colors.HIGHLIGHT as ColorOptions}
            fontSize={isMobile || isTab ? 14 : 18}
            lineHeight={isMobile ? 20 : 30}
            fontFamily="jiotype-medium">
            {staticStrings.enablesPayment}
            <Box alignSelf="center" pl={10} top={6}>
              <Image height={25} width={25} source={rightArrow} />
            </Box>
          </Text>
        </Box>
      </Box>
    </Box>
  )
}

export default BusinessNeeds
